import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AccommodationsPage from './pages/AccommodationsPage';
import FAQPage from './pages/FAQPage';
import SchedulePage from './pages/SchedulePage';
import { useNavbarVisibility } from './hooks/useNavbarVisibility';
import './App.css';
import ScrollToTop from './components/ScrollToTop';

function AppContent() {
  const isNavbarVisible = useNavbarVisibility();

  return (
    <div className="App">
      <Header isNavbarVisible={isNavbarVisible} />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home isNavbarVisible={isNavbarVisible} />} />
        <Route path="/accommodations" element={<AccommodationsPage />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/schedule" element={<SchedulePage />} />
      </Routes>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
